export const Logo = ({ className = "", testid = "brand-logo" }) => {
  return (
    <a
      href="#inicio"
      data-testid={testid}
      className={`inline-flex items-center group ${className}`}
      aria-label="Previsa Saúde"
    >
      <img
        src="/previsa-logo.png"
        alt="Previsa Saúde"
        className="h-10 md:h-11 w-auto select-none"
        draggable="false"
      />
    </a>
  );
};
